import Footer from "../../components/common/layout/Footer";
import { Breadcrumbs, IntroSection, OtherServices, OurProcess, WhyChooseUs } from "@/components/features/applicaionDevelopment";
import SEO from "@/components/common/seo/seo";
import CallToAction from "@/components/common/sections/CallToAction";

export default function ApplicationDevelopment() {
    return(
        <div>
            <SEO
                title="Application Development - SAN micron"
                description="Discover our Application Development services, where we create custom software solutions tailored to your business needs."
            />
            <Breadcrumbs />
            <IntroSection />
            <WhyChooseUs />
            <OurProcess />
            <CallToAction 
                title="Ready to transform your ideas into reality?"
            />
            <OtherServices />
            <Footer />
        </div>
    );
}